export default __webpack_public_path__ + "static/syncap-5a411bdef990394de0b2a9de5aa2bce2.svg";